import { type FC } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { StepLayout } from '@/app/[locale]/(not-authorized)/account/login/components/Login/components/TwoFaSetup/components/StepLayout';
import { Flex } from '@/components/common/Flex';
import { QrCode } from '@/components/common/QrCode';
import type { StepParams } from '@/hooks/use-stepper';

import styles from './ScanStep.module.scss';

type ScanStepProps = {
  stepParams: StepParams;
  qrCodeData: string;
  goToStep0: () => unknown;
  onSubmit: () => unknown;
};

export const ScanStep: FC<ScanStepProps> = (props) => {
  const { stepParams, qrCodeData, goToStep0, onSubmit } = props;

  const form = useForm({
    mode: 'onBlur',
  });

  const { handleSubmit } = form;

  return (
    <StepLayout
      stepParams={stepParams}
      goToStep0={goToStep0}
      renderForm={({ buttons }) => (
        <FormProvider {...form}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Flex direction="column" gap={4}>
              <div className={styles.qrCodeContainer}>
                <QrCode data={qrCodeData} />
              </div>

              {buttons}
            </Flex>
          </form>
        </FormProvider>
      )}
    />
  );
};
